/**
 * tokenUtils — W2.4
 *
 * Hilfsfunktionen für API-Token-Management.
 */
import { formatDistanceToNow } from 'date-fns'
import { activeBcp47, activeDateFnsLocale } from '../../lib/locale'

/**
 * Formatiert last_used_at als relative Zeit auf Deutsch.
 * Gibt null zurück wenn lastUsedAt null ist (Anzeige "Noch nie genutzt" obliegt dem Aufrufer).
 */
export function formatLastUsed(lastUsedAt: string | null): string | null {
  if (!lastUsedAt) return null
  return formatDistanceToNow(new Date(lastUsedAt), { addSuffix: true, locale: activeDateFnsLocale() })
}

/**
 * Formatiert ein ISO-Datum als lesbares Datum (DD.MM.YYYY).
 */
export function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString(activeBcp47(), {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  })
}

/**
 * Copy-to-Clipboard mit Fallback für ältere Browser.
 */
export async function copyToClipboard(text: string): Promise<void> {
  if (navigator.clipboard) {
    await navigator.clipboard.writeText(text)
  } else {
    const ta = document.createElement('textarea')
    ta.value = text
    document.body.appendChild(ta)
    ta.select()
    document.execCommand('copy')
    document.body.removeChild(ta)
  }
}
